import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getBinInventory = {
  name: "getBinInventory" as const,
  input: z.object({ storageLocationId: storageLocationIdFormat.schema }),
  output: z.object({
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        quantity: z.number(),
        lastCountedAt: z.string().nullable(),
        inventoryItemId: inventoryItemIdFormat.schema.nullable(),
        lotNumber: z.string().nullable(),
        expirationDate: z.string().nullable(),
      }),
    ),
  }),
};
